import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=305b4ea4"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=305b4ea4&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305b4ea4')) {
      api.createRecord('305b4ea4', component.options)
    } else {
      api.reload('305b4ea4', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=305b4ea4", function () {
      api.rerender('305b4ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wordDia/upload.vue"
export default component.exports